import script from "./select.vue?vue&type=script&setup=true&lang=ts"
export * from "./select.vue?vue&type=script&setup=true&lang=ts"

import "./select.vue?vue&type=style&index=0&id=1fdce465&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdce465"]])

export default __exports__